import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationStart, Router } from '@angular/router';
import { IdentityStorage } from 'app/auth/_models/identity.storage';
import { ModalJustificativaComponent } from 'app/components/modal-justificativa/modal-justificativa.component';
import { SolicitacaoAuxSaudeService } from 'app/service/solicitacao-aux-saude/solicitacao-aux-saude.service';
import { ServicoEstadoFiltro } from 'app/service/ServicoEstadoFiltro/servico-estado-filtro.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-lista-solicitacoes',
  templateUrl: './lista-solicitacoes.component.html',
  styleUrls: ['./lista-solicitacoes.component.sass']
})
export class ListaSolicitacoesComponent implements OnInit {
  private destroy$ = new Subject<void>();

  readonly perfisAcesso: string[] = ["CPREV_USER", "CPREV_ADMIN", "SEGESP_PRE_ADMIN", "AEP_PRE_ADMIN", "SEGESP_ADMIN", "AEP_ADMIN", "SEGESP_PRE_USER", "AEP_PRE_USER"];

  matricula: number = null
  nome: string = null;
  protocolo: string = null;
  dataInicio: Date = null;
  dataFim: Date = null;
  status: number = null;
  setor: number = null;
  listaStatus = []
  listaSetor = []
  usuarioGestao: boolean = false;
  novo:boolean = false;
  pageIndex = 0;
  pageSize: number = 5;
  totalElements: number;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['protocolo', 'nome', 'matricula', 'quantidadeDependentes', 'valorTotal', 'dataEnvio', 'setor', 'status', 'acoes'];
  constructor(
    private solicitacaoAuxSaudeService: SolicitacaoAuxSaudeService,
    private servicoEstadoFiltro: ServicoEstadoFiltro,
    public identityStorage: IdentityStorage,
    private router: Router,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    const estadoFiltro = this.servicoEstadoFiltro.obterEstadoFiltro();
    if (estadoFiltro) {
      this.matricula = estadoFiltro.matricula;
      this.nome = estadoFiltro.nome;
      this.protocolo = estadoFiltro.protocolo;
      this.dataInicio = estadoFiltro.dataInicio;
      this.dataFim = estadoFiltro.dataFim;
      this.setor = estadoFiltro.setor;
      this.status = estadoFiltro.status;
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      takeUntil(this.destroy$)
    ).subscribe((event: NavigationStart) => {
      if (event.url !== '/auxilio-saude/lista-solicitacoes' && !event.url.startsWith('/visualizar-solicitacao/')) {
        this.servicoEstadoFiltro.definirEstadoFiltro(null);
      }
    });
    
    this.isUsuarioCPREV();
    this.loadDados()
    this.onPageChange({ pageIndex: this.pageIndex, pageSize: this.pageSize, length: this.totalElements });
    this.botaoNovo()
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isUsuarioCPREV() {
    this.usuarioGestao = this.identityStorage.getUserAuthData().roles.some(role => {
      return this.perfisAcesso.includes(role.nome);
    });
    if (!this.usuarioGestao) {
      this.nome = this.identityStorage.getUserAuthData().nome;
      this.matricula = this.identityStorage.getUserAuthData().matricula;
    }
  }

  loadDados() {
    this.solicitacaoAuxSaudeService.getListaStatus().subscribe((result) => {
      this.listaStatus = result;
      if(this.usuarioGestao) {
        let index = this.listaStatus.findIndex(item => item.descricao == 'RASCUNHO')
        index >= 0 && this.listaStatus.splice(index, 1);
        this.solicitacaoAuxSaudeService.getListaSetor().subscribe((result) => {
          this.listaSetor = result;
        });
      }
    });
  }

  pesquisar() {
    this.servicoEstadoFiltro.definirEstadoFiltro({
      matricula: this.matricula,
      nome: this.nome,
      protocolo : this.protocolo,
      dataInicio : this.dataInicio,
      dataFim : this.dataFim,
      setor : this.setor,
      status : this.status
    });

    this.onPageChange({ pageIndex: 0, pageSize: this.pageSize, length: this.totalElements });
  }

  botaoNovo(){
    if(!this.usuarioGestao){
      this.solicitacaoAuxSaudeService.getPermitePreencher().subscribe((result) => {
        this.novo = result
      })
    }
  }

  novaSolicitacao(){
    this.router.navigate(['solicitacao-auxilio-saude'])
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    let month = (date.getMonth() + 1).toString();
    let day = date.getDate().toString();

    month = month.padStart(2, '0');
    day = day.padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    const filter = {
      pagina: event.pageIndex,
      tamanho: event.pageSize,
      matricula: this.matricula || '',
      nome: this.nome || '',
      dataInicio: this.dataInicio ? this.formatDate(this.dataInicio) : '',
      dataFim: this.dataFim ? this.formatDate(this.dataFim) : this.dataInicio ? this.formatDate(new Date()) : '',
      status: this.status || '',
      setor: this.setor || '',
      protocolo: this.protocolo || '',
    }
    let service
    if (this.usuarioGestao) {
      service = this.solicitacaoAuxSaudeService.getListaSolicitacoesCPREV(filter);
    }
    else {
      service = this.solicitacaoAuxSaudeService.getListaSolicitacoes(filter);
    }
    service.subscribe(response => {
      this.dataSource = new MatTableDataSource(response.content);
      this.totalElements = response.totalElements;
    });
  }

  visualizar(solicitacao: any) {
    if (this.usuarioGestao) {
      this.router.navigate([`visualizar-solicitacao/${solicitacao.id}`])
    }
    else {
      this.router.navigate([`solicitacao-auxilio-saude/${solicitacao.id}`])
    }
  }

  openDialog(solicitacao): void {
    this.dialog.open(ModalJustificativaComponent, {
      width: '600px',
      data: {
        titulo: solicitacao?.tipoRejeicao,
        mensagem: "Justificativa  da Recusa",
        justificativa: solicitacao?.justificativa,
        botaoOk: "Fechar",
      }
    });
  }

  rejeitada(status): boolean {
    return status === 3 || status === 5;
  }
}
